/** Delivery-agent roster rows may expose id under several keys. */
export function getDeliveryAgentRecordId(agent) {
  if (!agent || typeof agent !== 'object') return '';
  const id =
    agent.userId ??
    agent.User_Id ??
    agent.userID ??
    agent.user_id ??
    agent.id ??
    agent.Id ??
    agent.UserId;
  if (id === null || id === undefined || id === '') return '';
  return String(id);
}

export function getDeliveryAgentDisplayName(agent) {
  if (!agent || typeof agent !== 'object') return 'User';
  const n =
    agent.user_name ??
    agent.userName ??
    agent.UserName ??
    agent.User_Name ??
    `${agent.firstName || agent.first_name || ''} ${agent.lastName || agent.last_name || ''}`.trim();
  return typeof n === 'string' && n.trim() !== '' ? n.trim() : 'User';
}

export function getDeliveryAgentPhone(agent) {
  if (!agent || typeof agent !== 'object') return '';
  const p = agent.mobile ?? agent.Mobile ?? agent.contactNumber ?? agent.phone ?? agent.Phone ?? '';
  return String(p ?? '').trim();
}

export function deliveryAgentsToSelectOptions(agents) {
  return (agents || []).map((agent) => {
    const rid = getDeliveryAgentRecordId(agent);
    const phone = getDeliveryAgentPhone(agent);
    const name = getDeliveryAgentDisplayName(agent);
    return {
      value: rid,
      label: phone ? `${name} — ${phone}` : name,
    };
  });
}

const DELIVERY_AGENT_ROLE_PATTERN = /delivery/i;

export function isDeliveryAgentUser(user) {
  const roles = user?.roles ?? user?.roleNames ?? [];
  return (Array.isArray(roles) ? roles : []).some((r) =>
    DELIVERY_AGENT_ROLE_PATTERN.test(String(r))
  );
}
